export const REGEX={
    email:new RegExp('/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i'),
    numberPattern: new RegExp('^\.[0-9]+(\.[0-9][0-9]?)?'),
    numberPatternQuantity: new RegExp('^[0-9]+(\.[0-9][0-9]?)?'),
    numberPatternNoComma: new RegExp('^[0-9]+$'),
}
